var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.ready)?_c('Loading'):_vm._e(),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.ready),expression:"ready"}]},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }